import { Component, Input, } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { selectOrganization } from './organizations.actions';
import { selectWorkspace } from '../workspaces/workspaces.actions';
import { Config } from '../universal-config';

@Component({
  selector: 'nns-organization-select',
  template: `
    <div class="nns-organization-select">
      <div class="nns-select" (clickOutside)="isShowDropdown = false">
        <div class="nns-select-item--wrapper" (click)="onToggleDropdown()">
          <div class="nns-select-item" *ngIf="selectedOrganization">
            <div class="nns-select-item-logo">
              <nns-icon icon="building" flex="none" *ngIf="!selectedOrganization.smallLogoStoredFileUUID"></nns-icon>
              <img src="{{fileUrl + selectedOrganization.smallLogoStoredFileUUID}}" *ngIf="selectedOrganization.smallLogoStoredFileUUID"/>
            </div>
            <div class="nns-select-item--text">
              <div class="nns-select-item-title">{{selectedOrganization.title}}</div>
            </div>
            <span class="nns-header-profile-arrow nns-animated active" *ngIf="organizations && organizations.length"></span>
          </div>
        </div>
        <div class="nns-select-dropdown" *ngIf="isShowDropdown">
          <div class="nns-select-item"
            *ngFor="let organization of organizations" (click)="onSelectOrganization(organization.globalId)"
            [ngClass]="{'active': selectedOrganization && selectedOrganization.globalId == organization.globalId}">
            <div class="nns-select-item-logo">
              <nns-icon icon="building" flex="none" *ngIf="!organization.smallLogoStoredFileUUID"></nns-icon>
              <img src="{{fileUrl + organization.smallLogoStoredFileUUID}}" *ngIf="organization.smallLogoStoredFileUUID"/>
            </div>
            <div class="nns-select-item--text">
              <div class="nns-select-item-title">{{organization.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

  .nns-select{
    position: relative;
  }

  .nns-select-dialog-title{
    font-size: 13px;
    font-weight: bold;
  }

  .nns-select-item{
    display: flex;
    padding: 8px;
    border-radius: 4px;
    transition: 0.3s;
    transition-property: background-color;
    align-items: center;
    cursor: pointer;
    position: relative;
  }

  .nns-select-item:hover, .nns-select-item.active{
    background-color: rgba(0, 0, 0, 0.08);
  }

  .nns-select-item__disabled:hover{
    cursor: default;
    background-color: transparent;
  }

  .nns-select-item-logo{
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
    background-color: #F5F5F5;
    border-radius: 50%;
    background-size: cover;
  }

  .nns-select-item-logo img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  .nns-select-item-logo__account{
    background-color: #8BC34A;
  }

  .nns-select-item-logo__active{
    background-color: transparent;
  }

  .nns-select-item--text{
    width: calc(100% - 35px);
  }

  .nns-select-item-title{
    font-weight: bold;
    font-size: 13px;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
    white-space: nowrap;
  }

  .nns-select-item-desc{
    font-size: 12px;
    line-height: 16px;
    opacity: 0.6;
  }

  .nns-header-profile-arrow {
    display:block;
    content:"";
    height:0;
    border:none;
    border:4px solid transparent;
    border-top:4px solid rgba(0, 0, 0, 0.6);
    margin:6px 0 0 8px;
    margin-left: auto;
  }
  .nns-header-profile-button-active .nns-header-profile-arrow {
    border-top:none;
    border-bottom:4px solid rgba(0, 0, 0, 0.6);
  }

  .nns-select-dropdown{
    margin-top: 1px;
    position: absolute;
    left: 0;
    top: 100%;
    background-color: #fff;
    box-shadow: 0px 9px 14px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    width: 100%;
    max-height: 300px;
    overflow: hidden;
    overflow-y: auto;
    z-index: 1;
  }

  .icon-building{
    min-height: 16px;
    min-width: 16px;
  }

  :host /deep/ .nns-select-dialog-content {
    margin: auto;
  }
`, `
  :host-context(.nns-theme-night) .nns-select-dropdown {
    background: #292E32;
    box-shadow: 4px 4px 38px rgba(19, 30, 32, 0.66);
  }
  :host-context(.nns-theme-night) .nns-header-profile-arrow {
    border-top-color: #fff;
  }
`]
})
export class OrganizationSelectComponent {
  @Input() profile;
  @Input() organizations;
  @Input() selectedOrganization;
  fileUrl: string;
  isShowDropdown: boolean;

  constructor(
    public _store: Store<IAppState>,
    public _config: Config,
  ) {
    this.fileUrl = this._config.get('BOX_URL') + '/file/';
  }

  onToggleDropdown() {
    if(this.organizations && this.organizations.length) {
      this.isShowDropdown = !this.isShowDropdown;
    }
  }

  onSelectOrganization(organizationId){
    this._store.dispatch(selectOrganization(organizationId));
    this._store.dispatch(selectWorkspace(null, organizationId));
    this.isShowDropdown = false;
  }

}
